import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "home-meet" }
const _hoisted_3 = { class: "container" }

import castingProcess from '@/components/web/castingProcess.vue';
import headText from '@/components/web/headText.vue';
import { processCollection } from '@/data/processCollection';
import Capabilities from '@/components/web/widgets/Capabilities.vue';
import { computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { usePageData } from '@/composables/usePageData'

import HomeMaterial from '@/components/web/widgets/HomeMaterial.vue';
import IndustrySlider from '@/components/web/widgets/IndustrySlider.vue';
import HomeService from '@/components/web/content/HomeService.vue';

// 使用 vue-i18n
type imgTextItem = {
    text: string;
}



type imgTitleItem = {
    imgUrl: string;
    title: string;
    text: string;
    link: string;
}

type videoItem = {
    imgUrl: string;
    videoUrl: string;
    text: string;
}


//主题内容

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexService',
  setup(__props) {

const { locale, t, tm } = useI18n();


// 这里演示一下如何实现复杂类型的定义，使用ts接口继承

// 其实不用这么复杂，只是演示而已

const companyIntroductionUl = computed<string[]>(() => {
    return tm('index.service.companyIntroductionUl')
});




//h3title
const h3Title = t('index.service.h2pLContent.h3Title')
//headText
const h2pLContent = computed<h2pLContentType>(() => [{
    pList: tm('index.service.h2pLContent.pList').map((text: string) => text)
}]);

// 响应语言切换的计算属性
// 工作材料图片集合
const localizedMaterials = computed<imgTitleItem[]>(() => [
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/aluminium-die-casting-2918-!j.webp",
        title: t('index.service.homeMaterial.aluminum.title'),
        text: t('index.service.homeMaterial.aluminum.text'),
        link: "/aluminum-casting"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/zinc-die-casting-!j.webp",
        title: t('index.service.homeMaterial.zinc.title'),
        text: t('index.service.homeMaterial.zinc.text'),
        link: "/zinc-casting"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/magnesium-die-casting-!j.webp",
        title: t('index.service.homeMaterial.magnesium.title'),
        text: t('index.service.homeMaterial.magnesium.text'),
        link: "/magnesium-casting"
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/minghe-more-cast-material-in-china-!j.webp",
        title: t('index.service.homeMaterial.other.title'),
        text: t('index.service.homeMaterial.other.text'),
        link: "/other-cast-material"
    }
]);

// 行业集合
const localizedIndustries = computed<imgTextItem[]>(() => [
    { text: t('index.service.industry.car') },
    { text: t('index.service.industry.motorcycle') },
    { text: t('index.service.industry.mechanical') },
    { text: t('index.service.industry.lockingCylinder') },
    { text: t('index.service.industry.bulletTrain') },
    { text: t('index.service.industry.bicycle') },
    { text: t('index.service.industry.shipbuilding') },
    { text: t('index.service.industry.robotics') },
    { text: t('index.service.industry.oilGas') },
    { text: t('index.service.industry.medical') },
    { text: t('index.service.industry.signalReception') },
    { text: t('index.service.industry.optical') },
    { text: t('index.service.industry.camera') },
    { text: t('index.service.industry.sportsEquipment') },
    { text: t('index.service.industry.beauty') },
    { text: t('index.service.industry.lighting') },
    { text: t('index.service.industry.furniture') },
    { text: t('index.service.industry.electronics') },
    { text: t('index.service.industry.scientific') },
    { text: t('index.service.industry.sports') },
    { text: t('index.service.industry.semiconductors') }
]);

// 压铸加工视频集合
const localizedVideos = computed<videoItem[]>(() => [
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/dusting-in-minghe-!p.webp",
        videoUrl: "https://c74.hongcdn.com/uploads/2102/dusting-in-minghe.mp4",
        text: t('index.service.homeMeet.videos.dustRemoval')
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/die-casting-process-and-after-!p.webp",
        videoUrl: "https://c74.hongcdn.com/uploads/2102/die-casting-process-and-after.mp4",
        text: t('index.service.homeMeet.videos.dieCastingProcess')
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/die-casting-machine-shop-!p.webp",
        videoUrl: "https://c74.hongcdn.com/uploads/2102/die-casting-machine-shop.mp4",
        text: t('index.service.homeMeet.videos.machineBase')
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/deburring-in-minghe-!p.webp",
        videoUrl: "https://c74.hongcdn.com/uploads/2102/deburring-in-minghe.mp4",
        text: t('index.service.homeMeet.videos.deburring')
    },
    {
        imgUrl: "https://c74.hongcdn.com/uploads/2102/cnc-turning-in-minghe-1-!p.webp",
        videoUrl: "https://c74.hongcdn.com/uploads/2102/cnc-turning-in-minghe-1.mp4",
        text: t('index.service.homeMeet.videos.cncTurning')
    }
]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Capabilities),
    _createVNode(HomeMaterial),
    _createVNode(IndustrySlider),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(HomeService)
      ])
    ])
  ]))
}
}

})